import React from "react";
import styled from "styled-components";
import Tabs from "./Tabs";
import { useCoursesContext } from "../context/courses_context";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
const CoursesList = () => {
  const { courses } = useCoursesContext();
  const { user, isAuthenticated, isLoading } = useAuth0();
  const navigate = useNavigate();

  return (
    <CoursesListWrapper>
      <div className="container">
        {isAuthenticated && user && user["email"].includes("faculty") && (
          <h2
            onClick={() => {
              return navigate("/courses/xMHCZl");
            }}
            style={{
              padding: "0.5em",
              border: "1px dashed #000",
              width: "fit-content",
              marginBottom: "1em",
              background: "#F5F5CF",
              cursor: "pointer",
            }}
          >
            Add Your Own Course
          </h2>
        )}
        <div className="courses-list-top">
          <h2>A broad selection of courses</h2>
          <p>
            Choose from 205, 000 online video courses with new additions
            published every month
          </p>
        </div>
        <Tabs course={courses} />
      </div>
    </CoursesListWrapper>
  );
};
const CoursesListWrapper = styled.div`
  padding: 40px 0;
  .courses-list-top p {
    font-size: 1.8rem;
  }
`;
export default CoursesList;
